import React, { useEffect, useState } from 'react';
import { bool } from 'prop-types';
import AnimateHeight from 'react-animate-height';

const AnimatedContainer = ({ children, isVisible, ...rest }) => {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const newHeight = isVisible ? 'auto' : 0;
    setHeight(newHeight);
  }, [isVisible]);

  return (
    <AnimateHeight duration={500} height={height} {...rest}>
      {children}
    </AnimateHeight>
  );
};

AnimatedContainer.propTypes = {
  isVisible: bool,
};

export { AnimatedContainer };
